import type { Action } from 'history';

export const NAME = 'Router';
export const NO_SCROLL = 'no-scroll';
export const ACTION: Record<Action, Action> = {
  PUSH: 'PUSH',
  POP: 'POP',
  REPLACE: 'REPLACE'
} as const;
